module.exports = "../static/media/banner_poster.1dbe9afe.png";